import { env } from "@/env";
import { KEYCLOAK_CLIENT_ID } from "@/lib/auth/keycloak-constants";
import Keycloak from "keycloak-js";

// Create a singleton instance that persists across hot reloads
let keycloakInstance: Keycloak | undefined;

export function getKeycloakInstance(): Keycloak {
  keycloakInstance ??= new Keycloak({
    url: env.VITE_KEYCLOAK_ISSUER,
    realm: "claimini",
    clientId: KEYCLOAK_CLIENT_ID,
  });
  return keycloakInstance;
}
